import { FileType } from 'src/app/crew-management-user/enums/file-type.enum';
import { ICompetenceWithStatus } from 'src/app/shared/user-view/models/competence-user.model';

export enum CompetenceMatrixColor {
  Green = 1,
  Yellow = 2,
  Red = 3,
  Orange = 4,
  White = 5,
}

export enum CompetenceMatrixPlanningModes {
  CurrentPersonnel = 'CurrentPersonnel',
  PlannedActivities = 'PlannedActivities',
}

export interface ICompetenceMatrixUser {
  userId: string;
  fullName: string;
  jobPosition: string;
  competenceStatuses: {
    competenceId: string;
    expiresAt: string;
    statusType: CompetenceMatrixColor;
    equivalentCompetences: ICompetenceWithStatus[];
    isRegisteredByEquivalentCompetence: boolean;
    isRegisteredDirectly: boolean;
    showOnMatrixIfNotRequired: boolean;
  }[];
  allowNotifications: boolean;
}
export interface ICompetenceSummaryItem {
  hasWarning: boolean;
  statusType: CompetenceMatrixColor;
  allPeopleRequired: number;
  peopleOk: number;
  percentageAllPeopleRequired: number;
  percentageOkPeople: number;
}

export interface ICompetenceMatrix {
  allCompetences: { id: string; name: string; code: string }[];
  result: {
    summary: { competencesSummaryItems: ICompetenceSummaryItem[] };
    table: {
      usersData: ICompetenceMatrixUser[];
    };
  };
}

export interface ICompetenceMatrixNotifications {
  departmentId: string;
  shiftId: string;
  pivotDate?: Date | string;
  userIds: string[];
  timeZoneOffsetInHours: number;
}

export interface ICompetenceMatrixParams {
  departmentId?: string;
  departmentIds?: string[];
  shiftId: string;
  tripId: string;
  onlyConfirmedOnBoard: boolean;
  onlyInPlannedActivity: boolean;
  excludedUserIds?: string[];
  excludedCompetences?: string[];
  excludedPositions?: string[];
  excludedRequirements?: number[];
  pivotDate?: Date | string;
  fileType?: FileType;
}
